import axios from "axios";

const api = axios.create({ baseURL: "/api" });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    const data = (err.response && err.response.data) || {};
    err.message = data.message || "Something went wrong";
    err.code = data.code;
    err.status = err.response && err.response.status;
    return Promise.reject(err);
  }
);

export default api;